/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Polling_Global_Dns_ServersInputs */

const en_polling_global_dns_servers = /** @type {(inputs: Polling_Global_Dns_ServersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polling Global DNS Servers`)
};

const es_polling_global_dns_servers = /** @type {(inputs: Polling_Global_Dns_ServersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultando servidores DNS globales`)
};

const fr_polling_global_dns_servers = /** @type {(inputs: Polling_Global_Dns_ServersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interrogation des serveurs DNS mondiaux`)
};

const de_polling_global_dns_servers = /** @type {(inputs: Polling_Global_Dns_ServersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Globale DNS-Server werden abgefragt`)
};

const ja_polling_global_dns_servers = /** @type {(inputs: Polling_Global_Dns_ServersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グローバルDNSサーバーをポーリング中`)
};

const zh_polling_global_dns_servers = /** @type {(inputs: Polling_Global_Dns_ServersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在轮询全球 DNS 服务器`)
};

const ar_polling_global_dns_servers = /** @type {(inputs: Polling_Global_Dns_ServersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يتم الآن استطلاع خوادم DNS العالمية`)
};

const id_polling_global_dns_servers = /** @type {(inputs: Polling_Global_Dns_ServersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melakukan Polling Server DNS Global`)
};

const it_polling_global_dns_servers = /** @type {(inputs: Polling_Global_Dns_ServersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interrogazione dei server DNS globali in corso`)
};

const ru_polling_global_dns_servers = /** @type {(inputs: Polling_Global_Dns_ServersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опрос глобальных серверов DNS`)
};

const pt_polling_global_dns_servers = /** @type {(inputs: Polling_Global_Dns_ServersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sondando Servidores DNS Globais`)
};

const ko_polling_global_dns_servers = /** @type {(inputs: Polling_Global_Dns_ServersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`글로벌 DNS 서버를 폴링하는 중`)
};

/**
* | output |
* | --- |
* | "Polling Global DNS Servers" |
*
* @param {Polling_Global_Dns_ServersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const polling_global_dns_servers = /** @type {((inputs?: Polling_Global_Dns_ServersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Polling_Global_Dns_ServersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_polling_global_dns_servers(inputs)
	if (locale === "es") return es_polling_global_dns_servers(inputs)
	if (locale === "fr") return fr_polling_global_dns_servers(inputs)
	if (locale === "de") return de_polling_global_dns_servers(inputs)
	if (locale === "ja") return ja_polling_global_dns_servers(inputs)
	if (locale === "zh") return zh_polling_global_dns_servers(inputs)
	if (locale === "ar") return ar_polling_global_dns_servers(inputs)
	if (locale === "id") return id_polling_global_dns_servers(inputs)
	if (locale === "it") return it_polling_global_dns_servers(inputs)
	if (locale === "ru") return ru_polling_global_dns_servers(inputs)
	if (locale === "pt") return pt_polling_global_dns_servers(inputs)
	return ko_polling_global_dns_servers(inputs)
});